import * as navigationConstants from './navigationConstants';


/**
 * @param location {object}
 * @returns {{payload: ((function(*=, *): (Object))|*), type: string}}
 */
export const onRouteChange = location => {

    return {
        payload: location,
        type: navigationConstants.ACTION_ROUTE_CHANGE
    };
};
